import React, { useState } from 'react';
import { useProducts } from '../../context/ProductContext';
import AdminHeader from './AdminHeader';
import StatsCards from './StatsCards';
import ProductsTable from './ProductsTable';
import ProductForm from './ProductForm';
import InventoryView from './InventoryView';
import { categories } from '../../data/initialProducts';

export default function Admin({ onSwitchToStore, onSignout }) {
  const { products, addProduct, updateProduct, deleteProduct } = useProducts();
  const [isEditing, setIsEditing] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [activeTab, setActiveTab] = useState('products');

  const handleAddProduct = () => {
    setCurrentProduct({
      name: '',
      category: 'Electronics',
      price: 0,
      image: '',
      stock: 0,
      description: ''
    });
    setIsEditing(true);
  };

  const handleEditProduct = (product) => {
    setCurrentProduct({ ...product });
    setIsEditing(true);
  };

  const handleSaveProduct = (product) => {
    if (product.id) {
      updateProduct(product);
    } else {
      addProduct(product);
    }
    setIsEditing(false);
    setCurrentProduct(null);
  };

  const handleDeleteProduct = (id) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      deleteProduct(id);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setCurrentProduct(null);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <AdminHeader onSwitchToStore={onSwitchToStore} onSignout={onSignout} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <StatsCards products={products} categories={categories} />

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="border-b border-gray-200">
            <div className="flex">
              <button
                onClick={() => setActiveTab('products')}
                className={`px-6 py-3 font-medium ${
                  activeTab === 'products'
                    ? 'border-b-2 border-red-600 text-red-600'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                Products
              </button>
              <button
                onClick={() => setActiveTab('inventory')}
                className={`px-6 py-3 font-medium ${
                  activeTab === 'inventory'
                    ? 'border-b-2 border-red-600 text-red-600'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                Inventory
              </button>
            </div>
          </div>
        </div>

        {activeTab === 'products' && !isEditing && (
          <ProductsTable
            products={products}
            onAddProduct={handleAddProduct}
            onEditProduct={handleEditProduct}
            onDeleteProduct={handleDeleteProduct}
          />
        )}

        {activeTab === 'inventory' && (
          <InventoryView products={products} />
        )}

        {isEditing && (
          <ProductForm
            product={currentProduct}
            categories={categories}
            onSave={handleSaveProduct}
            onCancel={handleCancel}
          />
        )}
      </div>
    </div>
  );
}